// extracted by mini-css-extract-plugin
export default {"bylineWithHeadshots":"KKPmQPr6oTWiKpv2L_TQ"};